function resetWords()
{   
	for (var i = 0; i <= window.stimFieldsMax; i++)
	{
		stimContainers[i].innerHTML = "";
		stimContainers[i].style.border = "none";
	}

  // document.getElementById("wordTarget").innerHTML = ""; document.getElementById("word1").innerHTML = ""; document.getElementById("word2").innerHTML = "";
  // document.getElementById("word3").innerHTML = ""; document.getElementById("word4").innerHTML = "";document.getElementById("word5").innerHTML = "";document.getElementById("word6").innerHTML = "";
  // document.getElementById("word1").style.border = "none"; document.getElementById("word2").style.border = "none"; document.getElementById("word3").style.border = "none";
  // document.getElementById("word4").style.border = "none";document.getElementById("word5").style.border = "none";document.getElementById("word6").style.border = "none";
}